import { forwardRef, HTMLAttributes } from 'react';

type AnimatedDivProps = HTMLAttributes<HTMLDivElement> & {
  transitionDuration: number;
};

export const AnimatedDiv = forwardRef<HTMLDivElement, AnimatedDivProps>(
  ({ style, transitionDuration, ...props }, ref) => {
    return <div style={{ transitionDuration: `${transitionDuration}ms`, ...style }} {...props} ref={ref} />;
  }
);
